(function () {
  if (!(window.Shopify && Shopify.designMode)) return;
  var proof = document.querySelector(".nn-proof");
  if (!proof) return;
  proof.classList.add("nn-proof--edit");

  function pct(n) {
    return Math.max(0, Math.min(100, Math.round(n)));
  }

  [].slice.call(proof.querySelectorAll("[data-nn-sticker]")).forEach(function (el) {
    var hint = document.createElement("div");
    hint.className = "nn-sticker-hint";
    hint.hidden = true;
    el.appendChild(hint);

    var drag = false;
    var ox = 0;
    var oy = 0;

    el.addEventListener("pointerdown", function (e) {
      if (e.target.closest("a")) return;
      drag = true;
      el.setPointerCapture(e.pointerId);
      var r = el.getBoundingClientRect();
      ox = e.clientX - r.left - r.width / 2;
      oy = e.clientY - r.top - r.height / 2;
      el.style.cursor = "grabbing";
      hint.hidden = false;
      e.preventDefault();
      e.stopPropagation();
    });

    el.addEventListener("pointermove", function (e) {
      if (!drag) return;
      var box = proof.getBoundingClientRect();
      var x = pct(((e.clientX - ox - box.left) / box.width) * 100);
      var y = pct(((e.clientY - oy - box.top) / box.height) * 100);
      var mobile = window.matchMedia("(max-width: 900px)").matches;
      if (mobile) {
        el.style.setProperty("--sx-m", x + "%");
        el.style.setProperty("--sy-m", y + "%");
      } else {
        el.style.setProperty("--sx", x + "%");
        el.style.setProperty("--sy", y + "%");
      }
      hint.textContent = "Left " + x + "%  ·  Top " + y + "%  — save these on the sticker block";
    });

    function end() {
      if (!drag) return;
      drag = false;
      el.style.cursor = "grab";
    }
    el.addEventListener("pointerup", end);
    el.addEventListener("pointercancel", end);
  });
})();
